import { render, staticRenderFns } from "./ck-content.vue?vue&type=template&id=3b437d52&scoped=true&"
import script from "./ck-content.vue?vue&type=script&lang=js&"
export * from "./ck-content.vue?vue&type=script&lang=js&"
import style0 from "./ck-content.vue?vue&type=style&index=0&id=3b437d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b437d52",
  null
  
)

export default component.exports